import { render, staticRenderFns } from "./TableIdeologias.vue?vue&type=template&id=732d9ef6&scoped=true&"
import script from "./TableIdeologias.vue?vue&type=script&lang=js&"
export * from "./TableIdeologias.vue?vue&type=script&lang=js&"
import style0 from "./TableIdeologias.vue?vue&type=style&index=0&id=732d9ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d9ef6",
  null
  
)

export default component.exports